import { captureException } from "@sentry/react";
import Cookies from "js-cookie";

import API from "../../api/api/API";

let refreshingPromise: Promise<any> | null = null;

export async function refreshToken(
  tenantID: string | undefined,
  logout: () => void,
  setCloudLogo?: (props: { tenantID: string; value: string }) => void,
  onSuccess?: () => void
): Promise<any> {
  if (refreshingPromise) return refreshingPromise;

  refreshingPromise = API.refreshToken(tenantID)
    .then((res) => {
      const { authenticationToken, cloudToken, cloudLogo } = res.data.data;

      Cookies.set("authenticationToken", authenticationToken, {
        expires: 7,
        sameSite: "strict",
        secure: true,
      });

      if (cloudToken) {
        Cookies.set(`authenticationToken_${tenantID}`, cloudToken, {
          expires: 7,
          sameSite: "strict",
          secure: true,
        });
      }

      if (setCloudLogo && cloudLogo) {
        setCloudLogo({ tenantID: tenantID || "", value: cloudLogo });
      }

      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      captureException({
        message: "Error getting Refresh Token",
        err,
      });
      logout();
    })
    .finally(() => {
      refreshingPromise = null;
    });

  return refreshingPromise;
}
